module.exports = __webpack_public_path__ + "static/media/make-public.36304920.svg";